/**
 * @desc 站点店铺-列表查询(敏感信息不返回)
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<
  Array<defs.basics.PlatformSiteShopDesensitizationResponseDto>
>;
export function request(
  params: API.basics.platformSiteShop.getDesensitizationList.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/platformSiteShop/listDesensitization`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
